<template>
  <div id="contenedor-editar-municipio">
    <v-form v-model="esFormularioValido" ref="agregarMunicipios">
      <v-card>
        <v-card-title class="secondary--text">
          Editar municipio
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            v-model="municipio.idEntidad"
            label="Entidad"
            :items="entidades"
            item-text="nombre"
            item-value="id"
            v-on:keypress.enter="mixActualizarMunicipio"
          >
          </custom-select>
          <custom-text-field
            label="Nombre del Municipio"
            v-model="municipio.nombre"
            v-on:keypress.enter="mixActualizarMunicipio"
          >
          </custom-text-field>
          <custom-text-field
            label="Nombre Corto del Municipio"
            v-model="municipio.nombreCorto"
            v-on:keypress.enter="mixActualizarMunicipio"
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarMunicipio"
            :disabled="!esFormularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoMunicipios from './mixCatalogoMunicipios';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosMunicipiosEditar',
  mixins: [mixCatalogoMunicipios],
  props: {
    municipioEditar: Object,
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      municipio: {
        idEntidad: this.municipioEditar.idEntidad,
        nombre: this.municipioEditar.nombre,
        nombreCorto: this.municipioEditar.nombreCorto,
      },
    };
  },

  methods: {
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.agregarMunicipios.reset();
    },
  },
};
</script>

<style>
</style>
